import appConfig from '@/config';

const injectScripts = () => {
  if (appConfig.enableGoogleTags && appConfig.googleTagManagerId) {
    const gtmId = appConfig.googleTagManagerId;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    const gTagsScriptElement = document.createElement('script');
    gTagsScriptElement.async = true;
    gTagsScriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.append(gTagsScriptElement);

    const gTagsIframe = document.createElement('noscript');
    gTagsIframe.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.prepend(gTagsIframe);
  }

  if (appConfig.statusPageEmbedUrl) {
    const statusPageScriptElement = document.createElement('script');
    statusPageScriptElement.src =
      'https://ngfln6n04fyr.statuspage.io/embed/script.js';
    document.body.append(statusPageScriptElement);
  }
};

export default injectScripts;
